import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import API from 'api/API';
import { DeviceSearchResponse } from 'api/Responses/SearchResponses';
import { SEARCH_QUERY_LENGTH } from 'utils/helpers/constants';
import useTenant from './useTenant';

interface UseQueryParts {
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  parts: DeviceSearchResponse[];
  loading: boolean;
}

// Hook to retrieve the parts from a search query
const useQueryParts = (): UseQueryParts => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [parts, setParts] = useState<DeviceSearchResponse[]>([]);
  const [debouncedQuery] = useDebounce(query, 500);
  const [tenant] = useTenant();

  const querySets = useCallback(async (query?: string) => {
    if (query && query.length >= SEARCH_QUERY_LENGTH) {
      setLoading(true);
      try {
        const response = await API.search(query, tenant);
        setParts(response.parts);
      } catch (error) {
        API.errorHandler(error);
      }
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    querySets(debouncedQuery);
  }, [debouncedQuery, querySets, tenant]);

  return { query, setQuery, parts, loading };
};

export default useQueryParts;
